import {createContext, useContext} from 'react';
import type {TableRecipeStyles} from '@deezer/next/shared/theme/components/D4CTable';

const fallback: TableRecipeStyles = {
	table: {},
	thead: {},
	tbody: {},
	th: {},
	td: {},
	caption: {},
};

export const TableStyleContext = createContext<TableRecipeStyles>(fallback);

export const useTableStyles = () => useContext(TableStyleContext);
